<template>
  <section class="special_course padding_top">
    <b-container>
      <b-row class="justify-content-center">
        <b-col xl="5">
          <div class="section_tittle">
            <slot name="title"/>
          </div>
        </b-col>
      </b-row>
      <b-row v-if="getPages != null">
        <b-col
          lg="4"
          sm="6"
          class="mt-3"
          v-for="page in getPages"
          :key="page.id"
        >

        
          <b-row>
           
            <m-c512 :image="page.thumbnail" :alt="page.title">
            
              <template #p-1>
                

                <router-link class="text-decoration-none"
                    :to="{ name: 'SinglePage', params: { slug: page.slug } }"
                  >
                   <p class="my=2 text-secondary">
                  {{ page.title }}
                </p>
                  </router-link>



              </template>
              <template #p-2>
                <b-col lg="6" md="12" sm="12" class="text-center text-coll">
                  <span class="text-danger">
                    {{ `${page.author.name} ${page.author.last_name}` }}</span
                  >
                </b-col>

                <b-col lg="6" md="12" sm="12" class="text-center">
                  <router-link
                    :to="{ name: 'SinglePage', params: { slug: page.slug } }"
                  >
                    <b-button
                      class="border-0 text-muted font-weight-bold text-center"
                      variant="transparent"
                    >
                      <p class="text-danger text-muted">ادامه مطلب</p>
                    </b-button>
                  </router-link>
                </b-col>
              </template>

              <template #pr-1>
                <div class="mt-2   ">
                  <router-link
                    v-for="category in page.category"
                    :key="category.id"
                    :to="{}"
                  >
                    <m-bt501 class="borderbt mr-1">{{ category.name }}</m-bt501>
                  </router-link>
                </div>
              </template>
            
            </m-c512>
           
          </b-row>
         
        </b-col>
      </b-row>
      <b-row>
        <pagination
          v-if="havePagination"
          :meta="paginationMeta"
          :on-change-page="changePage"
        />

        <slot name="more" />
      </b-row>
    </b-container>
  </section>
</template>

<script>
import { dateConverter } from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import Pagination from "@moeinmdn/mixitweb-front-classic-dashboard/src/plugin/components/dashboard/Pagination.vue";
import router from "@/router";
import { mapGetters } from "vuex";

export default {
  name: "pageCard",
  props: ["title", "havePagination"],
  components: { Pagination },
  computed: {
    ...mapGetters({
      paginationMeta: "Content/getPaginationMeta",
      pages: "Content/getContents",
    }),
    getPages() {
      if (this.showNumber) {
        const pages = this.pages;
        return pages.slice(0, this.pages);
      } else {
        return this.pages;
      }
    },
  },
  methods: {
    changePage(page) {
      const form = {
        type: "page",
        page: page,
      };
      this.$store.dispatch("Content/getContents", form);
      router.push({
        name: "page",
        query: { ...router.currentRoute.query, page: page },
      });
    },
    dateConverter(date) {
      return dateConverter(date, "/");
    },
  },
  async mounted() {
    const form = {
      type: "page",
      page: 1,
    };
    await this.$store.dispatch("Content/getContents", form);
  },
};
</script>

<style scoped>
.card {
  height: 100%;
}
.text-coll {
  white-space: pre-wram;
  font-size: 14px;
}
.borderbt {
  border-radius: 10px;
}


</style>
